import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding/text';
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/scss/styles.scss'

import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import * as serviceWorker from './assets/scripts/serviceWorker';
import App from './App';
import  { watchSaga } from './store/sagas';

import mainReducer from './store/reducers/main';
import getDropDownReducer from './store/reducers/getDropDownReducer';
 
import loadClientStyleReducer from './store/reducers/loadClientStyleReducer';
import checkNRICSessionReducer from './store/reducers/checkNRICSessionReducer';
import getApplicationReducer from './store/reducers/getApplicationReducer';
import generateOTPReducer from './store/reducers/generateOTPReducer';

import uploadFileReducer from './store/reducers/uploadFileReducer';
import submitApplicationReducer from './store/reducers/submitApplicationReducer';
import validateOTPReducer from './store/reducers/validateOTPReducer';
import getMyInfoDataReducer from './store/reducers/getMyInfoDataReducer';
import getConsentsReducer from './store/reducers/getConsentsReducer';
import loadingReducer from './store/reducers/loading';

import 'bootstrap/dist/css/bootstrap.min.css';
import axiosInterceptor from './axiosInterceptor';

const sagaMiddleware = createSagaMiddleware();
 
const rootReducer = combineReducers({
    main: mainReducer,
    getDropDownReducer,
    loadClientStyleReducer,
    checkNRICSessionReducer,
    getApplicationReducer,
    generateOTPReducer,
    uploadFileReducer,
    submitApplicationReducer,
    validateOTPReducer,
    getMyInfoDataReducer,
    getConsentsReducer,
    loading: loadingReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(sagaMiddleware)
));

axiosInterceptor(store);

sagaMiddleware.run(watchSaga);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
 document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
